import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBS70SvVHErClbjYylgB2hmB_7OThapShw",
  authDomain: "integrated-a8127.firebaseapp.com",
  projectId: "integrated-a8127",
  messagingSenderId: "85570369355",
  appId: "1:85570369355:web:a91585fb88ee34043b1ace",
  measurementId: "G-SQQ4BPF70Z",
};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
